import { ENTRA_ID_ROUTES, LOGIN_ROUTES, PORTAL_ESTIPULANTE_ROUTES, PREVIDENCIA_DIGITAL_INVOICING_ROUTES, PREVIDENCIA_DOWNLOAD_ADHESION_ROUTES, PREVIDENCIA_PARTICIPANTS_ROUTES, PREVIDENCIA_SUBCOMPANIES_ROUTES, REGISTER_POLICYHOLDER_ROUTES, VIDA_ADHESION_PROPOSAL_ROUTES, VIDA_DASHBOARD_PAYMENT_ROUTES, VIDA_LIST_SUBESTIPULANTES_ROUTES, VIDA_PAYMENT_ROUTES, VIDA_PROPONENTE_MAINTENANCE_ROUTES, VIDA_SEGURADO_MAINTENANCE_ROUTES, GIBS_ROUTES, DREF_ROUTES, VIDA_CEP_ROUTES } from './requestsService';

export class MessageService {
  private static normalizeRoute(route: string): string {
    if (!route) return '';
    const [pathOnly] = route.split('?');
    return pathOnly.replace(/\/+$/, '');
  }

  private static errorMessages: { [key: string]: { [key: number]: string } } = {
    [GIBS_ROUTES.POST_VERIFY_USER]: {
      400: 'CPF ou senha inválidos.',
      401: 'CPF ou senha inválidos.',
      404: 'CPF ou senha inválidos.',
      500: 'CPF ou senha inválidos.'
    },
    [LOGIN_ROUTES.POST_LIST_BUSINESS_LINKS]: {
      400: 'Erro ao buscar vínculos de negócio.',
      401: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhum vínculo de negócio encontrado.',
      500: 'Erro ao buscar vínculos. Tente novamente.'
    },
    [LOGIN_ROUTES.POST_GET_CONTACTS]: {
      400: 'Erro ao consultar contatos.',
      401: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhum contato encontrado.',
      500: 'Erro ao consultar contatos. Tente novamente.'
    },
    [LOGIN_ROUTES.POST_SEND_SMS]: {
      400: 'Erro ao enviar SMS.',
      401: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Telefone não encontrado.',
      500: 'Erro ao enviar código por SMS. Tente novamente.'
    },
    [LOGIN_ROUTES.POST_SEND_EMAIL]: {
      400: 'Erro ao enviar email.',
      401: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Email não encontrado.',
      500: 'Erro ao enviar código por email. Tente novamente.'
    },
    [LOGIN_ROUTES.POST_LOGIN_FINAL]: {
      400: 'Erro ao finalizar login.',
      401: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Dados do usuário não encontrados.',
      500: 'Erro ao finalizar login. Tente novamente.'
    },
    [GIBS_ROUTES.POST_RECOVER_USER]: {
      400: 'Não foi possível concluir a operação.',
      401: 'Não foi possível concluir a operação.',
      404: 'Nenhum usuário encontrado para o CPF informado.',
      500: 'Erro ao recuperar usuário. Tente novamente.'
    },
    [GIBS_ROUTES.POST_RECOVER_PASSWORD]: {
      400: 'Não foi possível concluir a operação.',
      404: 'Não foi possível concluir a operação.',
      500: 'Erro ao realizar a operação, tente novamente.'
    },
    [REGISTER_POLICYHOLDER_ROUTES.POST_ADD_BASIC_PHYSICAL_PERSON_DATA]: {
      200: 'Operação realizada com sucesso.',
      400: 'Não existe registro para o CPF informado.',
      401: 'Não foi possível concluir a operação.',
      404: 'Não existe registro para o CPF informado.',
      500: 'Erro ao cadastrar segurado. Tente novamente.'
    },
    [REGISTER_POLICYHOLDER_ROUTES.POST_GET_LEGAL_ENTITY_BY_CNPJ]: {
      200: 'Operação realizada com sucesso.',
      400: 'Não existe registro para o documento informado.',
      401: 'Não foi possível concluir a operação.',
      404: 'Não existe registro para o documento informado.',
      500: 'Erro ao buscar segurado pelo documento informado. Tente novamente.'
    },
    [REGISTER_POLICYHOLDER_ROUTES.POST_GET_PHYSICAL_PERSON_BY_CPF]: {
      200: 'Operação realizada com sucesso.',
      400: 'Cadastro não encontrado.',
      401: 'Não foi possível concluir a operação.',
      404: 'Nenhum segurado encontrado com este CPF.',
      500: 'Erro ao buscar segurado por CPF. Tente novamente.'
    },
    [REGISTER_POLICYHOLDER_ROUTES.POST_LINK_PERSON_TO_BUSINESS_REPRESENTATION]: {
      200: 'Operação realizada com sucesso.',
      400: 'Não foi possível vincular pessoa ao negócio.',
      401: 'Não foi possível concluir a operação.',
      404: 'Representação de negócio não encontrada.',
      500: 'Erro ao vincular pessoa. Tente novamente.'
    },
    [REGISTER_POLICYHOLDER_ROUTES.POST_ADD_EMAIL]: {
      200: 'Operação realizada com sucesso.',
      400: 'Não foi possível adicionar o e-mail.',
      401: 'Não foi possível concluir a operação.',
      404: 'Dados não encontrados.',
      500: 'Erro ao adicionar e-mail. Tente novamente.'
    },
    [REGISTER_POLICYHOLDER_ROUTES.POST_ALTER_PASSWORD]: {
      200: 'Operação realizada com sucesso.',
      400: 'Senha atual inválida ou nova senha não atende aos requisitos.',
      401: 'Não foi possível concluir a operação.',
      404: 'Usuário não encontrado.',
      500: 'Erro ao alterar senha. Tente novamente.'
    },
    [REGISTER_POLICYHOLDER_ROUTES.GET_LIST_POLICIES_FOR_USER]: {
      200: 'Operação realizada com sucesso.',
      400: 'Parâmetros inválidos para listagem de apólices.',
      401: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Não foi possível carregar a apólice, tente novamente.',
      500: 'Erro ao listar apólices. Tente novamente.'
    },
    [VIDA_LIST_SUBESTIPULANTES_ROUTES.GET_LIST_SUBESTIPULANTES]: {
      200: 'Operação realizada com sucesso.',
      400: 'Não foi possível concluir a operação.',
      401: 'Não foi possível concluir a operação.',
      403: 'Não foi possível concluir a operação.',
      404: 'Não foi possível concluir a operação.',
      500: 'Não foi possível concluir a operação, tente novamente.'
    },
    [VIDA_PAYMENT_ROUTES.GET_PAYMENT_INVOICE_HISTORY]: {
      200: 'Operação realizada com sucesso.',
      400: 'Não foi possível carregar o histórico de pagamentos.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhum histórico de pagamento encontrado.',
      500: 'Erro ao buscar histórico de pagamento. Tente novamente.'
    },
    [VIDA_PAYMENT_ROUTES.GET_PAYMENT_INVOICE_DETAIL]: {
      200: 'Operação realizada com sucesso.',
      400: 'Não foi possível carregar os detalhes da fatura.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Fatura não encontrada.',
      500: 'Erro ao buscar detalhes da fatura. Tente novamente.'
    },
    [VIDA_PAYMENT_ROUTES.GET_PAYMENT_INVOICE_COMPETENCE]: {
      200: 'Operação realizada com sucesso.',
      400: 'Não foi possível carregar as competências faturadas.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhuma competência faturada encontrada.',
      500: 'Erro ao buscar competências faturadas. Tente novamente.'
    },
    [VIDA_DASHBOARD_PAYMENT_ROUTES.GET_DASHBOARD_PAYMENT_INVOICE_GRAPHIC]: {
      200: 'Operação realizada com sucesso.',
      400: 'Não foi possível carregar os dados gráficos.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhum dado gráfico encontrado.',
      500: 'Erro ao buscar dados gráficos. Tente novamente.'
    },
    [VIDA_ADHESION_PROPOSAL_ROUTES.GET_LIST_PROPOSAL_SUBESTIPULANTE]: {
      200: 'Operação realizada com sucesso.',
      400: 'Não foi possível carregar a lista de proponentes subestipulantes.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhum proponente subestipulante encontrado.',
      500: 'Erro ao buscar lista de proponentes subestipulantes. Tente novamente.'
    },
    [VIDA_ADHESION_PROPOSAL_ROUTES.GET_LIST_VALIDATION_PA_PROPOSITION]: {
      200: 'Operação realizada com sucesso.',
      400: 'Não foi possível carregar a lista de validação PA.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhuma proposta de validação PA encontrada.',
      500: 'Erro ao buscar lista de validação PA. Tente novamente.'
    },
    [VIDA_ADHESION_PROPOSAL_ROUTES.GET_HISTORY_PA_PROPOSAL]: {
      200: 'Operação realizada com sucesso.',
      400: 'Não foi possível carregar o histórico de parecer PA.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhum histórico de parecer PA encontrado.',
      500: 'Erro ao buscar histórico de parecer PA. Tente novamente.'
    },
    [VIDA_ADHESION_PROPOSAL_ROUTES.GET_REJECT_PA_PROPOSAL]: {
      400: 'Não foi possível carregar os motivos de recusa PA.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhum motivo de recusa PA encontrado.',
      500: 'Erro ao buscar motivos de recusa PA. Tente novamente.'
    },
    [VIDA_PROPONENTE_MAINTENANCE_ROUTES.POST_ADD_PROPONENTE_MAINTENANCE]: {
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Dados do proponente não encontrados.',
      500: 'Erro ao incluir dados do proponente. Tente novamente.'
    },
    [VIDA_PROPONENTE_MAINTENANCE_ROUTES.POST_ALTER_PROPONENTE_MAINTENANCE]: {
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Proponente não encontrado.',
      500: 'Erro ao alterar dados do proponente. Tente novamente.'
    },
    [VIDA_PROPONENTE_MAINTENANCE_ROUTES.POST_IMPORT_PROPONENTE_MAINTENANCE_LOT]: {
      400: 'Não foi possível importar os dados do proponente em lote.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Arquivo ou dados para importação não encontrados.',
      500: 'Erro ao importar dados do proponente em lote. Tente novamente.'
    },
    [VIDA_PROPONENTE_MAINTENANCE_ROUTES.GET_INATIVATE_PROPONENTE_MAINTENANCE]: {
      400: 'Não foi possível inativar ou excluir os dados do proponente.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Proponente não encontrado.',
      500: 'Erro ao inativar ou excluir dados do proponente. Tente novamente.'
    },
    [VIDA_PROPONENTE_MAINTENANCE_ROUTES.GET_PROPONENTE_MAINTENANCE_DETAIL]: {
      400: 'Não foi possível carregar os dados do proponente.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Dados do proponente não encontrados.',
      500: 'Erro ao buscar dados do proponente. Tente novamente.'
    },
    [VIDA_PROPONENTE_MAINTENANCE_ROUTES.GET_LAYOUT_IMPORT_SEGUR_VIDA]: {
      400: 'Não foi possível carregar o layout de importação.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Layout de importação não encontrado.',
      500: 'Erro ao buscar layout de importação. Tente novamente.'
    },
    [VIDA_SEGURADO_MAINTENANCE_ROUTES.GET_LIST_SEGURADO_MAINTENANCE]: {
      400: 'Não foi possível carregar a lista de segurados.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhum segurado encontrado.',
      500: 'Erro ao buscar lista de segurados. Tente novamente.'
    },
    [VIDA_SEGURADO_MAINTENANCE_ROUTES.POST_ADD_SEGURADO_MAINTENANCE]: {
      400: 'Não foi possível incluir os dados do segurado.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Dados do segurado não encontrados.',
      500: 'Erro ao incluir dados do segurado. Tente novamente.'
    },
    [VIDA_SEGURADO_MAINTENANCE_ROUTES.POST_ADD_CONJUGUE_SEGURADO_MAINTENANCE]: {
      400: 'Não foi possível incluir os dados do cônjuge segurado.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Dados do cônjuge segurado não encontrados.',
      500: 'Erro ao incluir dados do cônjuge segurado. Tente novamente.'
    },
    [VIDA_SEGURADO_MAINTENANCE_ROUTES.POST_ALTER_SEGURADO_MAINTENANCE]: {
      400: 'Não foi possível alterar os dados do segurado.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Segurado não encontrado.',
      500: 'Erro ao alterar dados do segurado. Tente novamente.'
    },
    [VIDA_SEGURADO_MAINTENANCE_ROUTES.POST_REMOVE_SEGURADO_MAINTENANCE]: {
      400: 'Não foi possível excluir os dados do segurado.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Segurado não encontrado.',
      500: 'Erro ao excluir dados do segurado. Tente novamente.'
    },
    [VIDA_SEGURADO_MAINTENANCE_ROUTES.GET_SEGURADO_MAINTENANCE_DETAIL]: {
      400: 'Não foi possível carregar os dados do segurado.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Segurado não encontrado.',
      500: 'Erro ao buscar dados do segurado. Tente novamente.'
    },
    [PREVIDENCIA_PARTICIPANTS_ROUTES.GET_SEARCH_PARTICIPANTS]: {
      400: 'Não foi possível carregar os participantes.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhum participante encontrado.',
      500: 'Erro ao buscar participantes. Tente novamente.'
    },

    [PREVIDENCIA_PARTICIPANTS_ROUTES.GET_PARTICIPANT_DETAIL]: {
      400: 'Não foi possível carregar os detalhes do participante.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhum detalhe de participante encontrado.',
      500: 'Erro ao buscar detalhes do participante. Tente novamente.'
    },

    [PREVIDENCIA_PARTICIPANTS_ROUTES.PUT_UPDATE_PARTICIPANT]: {
      400: 'Não foi possível atualizar o participante.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhum participante encontrado.',
      500: 'Erro ao atualizar participante. Tente novamente.'
    },

    [PREVIDENCIA_PARTICIPANTS_ROUTES.GET_CONTRACTS]: {
      400: 'Não foi possível carregar os contratos.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhum contrato encontrado.',
      500: 'Erro ao buscar contratos. Tente novamente.'
    },
    [PREVIDENCIA_SUBCOMPANIES_ROUTES.GET_SUBCOMPANIES]: {
      400: 'Não foi possível carregar as sucursais.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhuma sucursal encontrada.',
      500: 'Erro ao buscar sucursais. Tente novamente.'
    },
    [PREVIDENCIA_DOWNLOAD_ADHESION_ROUTES.GET_LIST_ADHESIONS]: {
      400: 'Não foi possícarregar os pagamentos da adesão.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhum pagamento da adesão encontrado para os filtros informados.',
      500: 'Erro ao buscar pagamentos da adesão. Tente novamente.'
    },
    [PREVIDENCIA_DOWNLOAD_ADHESION_ROUTES.GET_ADHESION_DETAIL]: {
      400: 'Não foi possível carregar os detalhes da adesão.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Detalhes da adesão não encontrados.',
      500: 'Erro ao buscar detalhes da adesão. Tente novamente.'
    },
    [PREVIDENCIA_DOWNLOAD_ADHESION_ROUTES.POST_DOWNLOAD_ADHESION]: {
      400: 'Não foi possível iniciar o download da adesão.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Registro da adesão não encontrado para download.',
      500: 'Erro ao iniciar o download da adesão. Tente novamente.'
    },
    [PREVIDENCIA_DIGITAL_INVOICING_ROUTES.POST_PAYMENT_DOWNLOAD]: {
      400: 'Não foi possível iniciar o download da fatura.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Registro da fatura não encontrado para download.',
      500: 'Erro ao iniciar o download da fatura. Tente novamente.'
    },
    [PREVIDENCIA_DIGITAL_INVOICING_ROUTES.GET_PAYMENTS]: {
      400: 'Não foi possível carregar os pagamentos.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhum pagamento encontrado.',
      500: 'Erro ao buscar pagamentos. Tente novamente.'
    },
    [PREVIDENCIA_DIGITAL_INVOICING_ROUTES.GET_PAYMENT_DETAIL]: {
      400: 'Não foi possícarregar os detalhes da fatura.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhum detalhe de fatura encontrado.',
      500: 'Erro ao buscar detalhes da fatura. Tente novamente.'
    },
    [ENTRA_ID_ROUTES.POST_ENTRA_LOGIN]: {
      400: 'Não foi possível concluir o login. Dados da autenticação inválidos.',
      401: 'Não foi possível autenticar. Perfil de backoffice inválido ou sessão expirada.',
      502: 'Não foi possível concluir o login. Tente novamente.',
      503: 'Serviço temporariamente indisponível. Tente novamente.',
    },
    [DREF_ROUTES.POST_VERIFY_ACCEPTANCE]: {
      400: 'Não foi possível verificar o aceite.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      500: 'Erro ao verificar o aceite. Tente novamente.'
    },
    [DREF_ROUTES.POST_INCLUDE_ACCEPTANCE]: {
      400: 'Não foi possível incluir o aceite.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      500: 'Erro ao incluir o aceite. Tente novamente.'
    },
    [DREF_ROUTES.POST_RECOVER_TERM_BY_IDENTIFIER]: {
      400: 'Não foi possível recuperar o termo.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhum termo encontrado.',
      500: 'Erro ao recuperar o termo. Tente novamente.'
    },
    [DREF_ROUTES.POST_LIST_TERMS_BY_IDENTIFIER]: {
      400: 'Não foi possível listar os termos.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi possível carregar os dados. Tente novamente.',
      404: 'Nenhum termo encontrado.',
      500: 'Erro ao listar os termos. Tente novamente.'
    },
    [VIDA_CEP_ROUTES.GET_OBTER_DADOS_LOGRADOURO_CONSULTA_CEP]: {
      400: 'Não foi possível carregar o CEP.',
      401: 'Não foi possível concluir a operação. Tente novamente.',
      403: 'Não foi ',
      404: 'Nenhum CEP encontrado.',
      500: 'Erro ao carregar o CEP. Tente novamente.'
    },
    [PORTAL_ESTIPULANTE_ROUTES.POST_REDIRECT]: {
      400: 'Não foi possível abrir o Web Vida. Verifique a apólice selecionada.',
      401: 'Sessão expirada. Faça login novamente para acessar o Web Vida.',
      403: 'Você não tem permissão para acessar o Web Vida.',
      500: 'Erro ao abrir o Web Vida. Tente novamente.'
    },
  } as const;

  /**
   * Returns only explicitly mapped message by route and status.
   * Missing route/status mapping returns null.
   */
  static getMappedErrorMessage(route: string, statusCode: number): string | null {
    const normalizedRoute = this.normalizeRoute(route);
    const routeMessages = this.errorMessages[normalizedRoute];
    return routeMessages?.[statusCode] ?? null;
  }

  /**
   * Add or update error messages for a specific route
   * @param route - The API route
   * @param messages - Object with status codes and their messages
   */
  static setRouteMessages(route: string, messages: { [key: number]: string }): void {
    this.errorMessages[route] = { ...this.errorMessages[route], ...messages };
  }

}
